import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: 10,
        width: 130,
        height: 30,
        borderRadius: 6,
        padding: '5px 4px',
        display: 'flex',
        alignItems: 'center',
        background: '#f1f1f1',
        border: '1px solid #e3e3e3',
    },
    input: {
        marginLeft: theme.spacing(1.5),
        flex: 1,
        color: 'black',
    },
    iconButton: {
        padding: 10,
        color: 'rgb(110 110 110 / 54%)',
    },
    divider: {
        height: 28,
        margin: 4,
    },
}));

export default function SearchInput(props) {
    const classes = useStyles();
    const [isSearch, setSearch] = useState(props.searchValue ? true : false);
    const [searchValue, setValue] = useState(props.searchValue || null);

    const handleSearchClick = () => {
        if (isSearch) {
            setValue('');
            props.onClick(null);
        } else {
            props.onClick(searchValue);
        }

        setSearch((prev) => !prev);
    };

    return (
        <Box component="form" className={classes.root} style={{ width: props.width }}>
            <InputBase
                className={classes.input}
                placeholder="Хайлт..."
                value={searchValue}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                inputProps={{ 'aria-label': 'search google maps' }}
            />
            <IconButton
                onClick={handleSearchClick}
                className={classes.iconButton}
                aria-label="search"
            >
                {!isSearch ? (
                    <SearchIcon fontSize="small" color="white" />
                ) : (
                    <CloseIcon fontSize="small" color="white" />
                )}
            </IconButton>
        </Box>
    );
}

SearchInput.defaultProps = {
    width: 130,
    onClick: null,
};
